<app-lista-dados
  [upTitulo]="'Lista de Tokens'"
  [upIcone]="'key'"
  [upCor]="'3F51B5'"
  [upDados]="tokens"
  [upColunas]="colunas"
  [upHabilitaEditarLinha]="true"
  [upPermitirEdicaoLinhaExistente]="false"
  [upHabilitaBotaoEditar]="true"
  [upTextoBotaoEditar]="'Permissões'"
  [upIconeBotaoEditar]="'security'"
  [upAcoesLinha]="acoesLinha"
  [upHabilitaBotaoExcluir]="true"
  [upTextoBotaoExcluir]="'Excluir'"
  [upIconeBotaoExcluir]="'delete'"
  [upLargura]="3"
  [upHabilitaContador]="true"
  [upCarregando]="carregando"
  (ueIniciarEdicaoLinha)="iniciar($event)"
  (ueSalvarLinha)="salvar($event)"
  (ueBotaoEditar)="abrirPermissoes($event)"
  (ueAcaoLinha)="executarAcaoLinha($event)"
  (ueBotaoExcluir)="excluir($event)">
</app-lista-dados>
